
<mat-card style="padding: 0.5in;">
	<!-- <mat-card-header> -->

	<div class="row" style="margin-bottom: 20px;">
		<div class="col-sm-6" style="text-align: left;">
			<button mat-raised-button (click)="closeDialog()">
				<mat-icon>close</mat-icon>
				Close
			</button>
		</div>
		<div class="col-sm-6" style="text-align: right;">
			<button mat-raised-button color="primary" (click)="printReport()">
				<mat-icon>print</mat-icon>
				Print Report
			</button>
		</div>
	</div>

	<!-- </mat-card-header> -->
	<mat-card-content style="overflow: auto; max-height: 80vh;">

		<kendo-pdf-export #pdf paperSize="letter" [scale]="0.75">

			<div class="report-content" style="font-family: Arial, Helvetica, sans-serif; background-image: url('assets/images/Border1.png'); background-repeat: no-repeat; background-position: center; background-size: 100% 100%; height: 11in; width: 8.5in; box-sizing: border-box;">
				<div style="padding-left: 0.25in;padding-right: 0.25in;padding-top: 0.75in;padding-bottom: 0.25in; box-sizing: border-box;">
					<div class="row">
						<div class="col-sm-1"></div>
						<div class="col-sm-2">
							<img src="assets/images/ORELAP.jpg" style="transform: scale(0.9); transform-origin: top left;" alt="Orelap Oregon Health Authority Seal" />
						</div>
						<div class="col-sm-6">
							<div class="row">
								<div class="col-sm-12" style="text-align:center">
									<span style="font-size: 30px"><strong>Oregon</strong></span>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12" style="text-align:center">
									<span style="font-size: 26px"><strong>Environmental Laboratory</strong></span>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12" style="text-align:center">
									<span style="font-size: 26px"><strong>Accreditation Program</strong></span>
								</div>
							</div>
						</div>
						<div class="col-sm-2" style="text-align: center;">
							<img src="assets/images/nelap2.jpg" style="display: block; margin: 0 auto; transform: scale(1.2); transform-origin: top center;" alt="Nelap Recognized" />
							<div style="text-align: center; margin-top: 15px;">
								<span style="font-size: 6pt;"><strong>NELAP Recognized</strong></span>
							</div>
						</div>
						<div class="col-sm-1"></div>
					</div>

					<div class="row">
						<div class="col-sm-12" style="text-align:center">
							<span style="font-size: 20px"><strong>{{certData.labName}}</strong></span>
						</div>
					</div>

					<div class="row" style="margin-top: 5pt">
						<div class="col-sm-12" style="text-align:center">
							<span style="font-size: 20px"><strong>{{certData.orelapId}}</strong></span>
						</div>
					</div>

					<div class="row" style="margin-top: 5pt">
						<div class="col-sm-12" style="text-align:center">
							<span style="font-size: 10pt;font-family: DejaVu Sans;">{{encodeForPdf(certData.address)}}</span>
						</div>
					</div>

					<div class="row" style="margin-top: 5pt">
						<div class="col-sm-12" style="text-align:center">
							<span style="font-size: 10pt">{{certData.city}}, {{certData.state}} {{certData.zip}}</span>
						</div>
					</div>

					<div class="row" style="margin-top: 5pt">
						<div class="col-sm-1"></div>
						<div class="col-sm-10">
							<span style="font-size: 9pt">IS GRANTED APPROVAL BY ORELAP UNDER THE 2016 TNI STANDARDS, TO
								PERFORM ANALYSES ON ENVIRONMENTAL SAMPLES IN MATRICES AS LISTED BELOW:</span>
						</div>
						<div class="col-sm-1"></div>
					</div>

					<div class="row" style="margin-top: 10pt">
						<div class="col-sm-1"></div>
						<div class="col-sm-10" style="font-size: 10pt">
							<table class="table table-condensed" style ="width: 100%;">
								<colgroup>
									<col style="width: 20%" />
									<col style="width: 20%" />
									<col style="width: 20%" />
									<col style="width: 20%" />
									<col style="width: 20%" />
								</colgroup>
								<thead>
									<tr>
									<th style="border-bottom: 2px solid #000;">Air</th>
									<th style="border-bottom: 2px solid #000;">Drinking Water</th>
									<th style="border-bottom: 2px solid #000;">Non-Potable Water</th>
									<th style="border-bottom: 2px solid #000;">Solids & Chem. Waste</th>
									<th style="border-bottom: 2px solid #000;">Tissue</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let name of uniqueAnalyteNames">
										<td style="border-top:none;text-align: center;">{{ getAnalytesByMatrix(name, 'Air') }}</td>
										<td style="border-top:none;text-align: center;">{{ getAnalytesByMatrix(name, 'Drinking Water') }}</td>
										<td style="border-top:none;text-align: center;">{{ getAnalytesByMatrix(name, 'Non-Potable Water') }}</td>
										<td style="border-top:none;text-align: center;">{{ getAnalytesByMatrix(name, 'Solids') }}</td>
										<td style="border-top:none;text-align: center;">{{ getAnalytesByMatrix(name, 'Biological Tissue') }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="col-sm-1"></div>
					</div>

					<div class="row" style="margin-top: 50pt">
						<div class="col-sm-1"></div>
						<div class="col-sm-10">
							<span style="font-size: 9pt">AND AS RECORDED IN THE LIST OF APPROVED ANALYTES, METHODS,
								ANALYTICAL TECHNIQUES, AND FIELDS OF TESTING ISSUED CONCURRENTLY WITH THIS CERTIFICATE AND
								REVISED AS NECESSARY.</span>
						</div>
						<div class="col-sm-1"></div>
					</div>

					<!-- <div class="row">
						<div class="col-sm-1"></div>
						<div class="col-sm-10">
							<span style="font-size: 11pt"></span>
						</div>
						<div class="col-sm-1"></div>
					</div> -->

					<div class="row" style="margin-top: 10pt">
						<div class="col-sm-1"></div>
						<div class="col-sm-10">
							<span style="font-size: 9pt">ACCREDITED STATUS DEPENDS ON SUCCESSFUL ONGOING PARTICIPATION IN
								THE PROGRAM AND CONTINUED COMPLIANCE WITH THE STANDARDS.</span>
						</div>
						<div class="col-sm-1"></div>
					</div>

					<!-- <div class="row">
						<div class="col-sm-1"></div>
						<div class="col-sm-10">
							<span style="font-size: 11pt">CONTINUED COMPLIANCE WITH THE STANDARDS.</span>
						</div>
						<div class="col-sm-1"></div>
					</div> -->

					<div class="row" style="margin-top: 10pt">
						<div class="col-sm-1"></div>
						<div class="col-sm-10">
							<span style="font-size: 9pt">CUSTOMERS ARE URGED TO VERIFY THE LABORATORY'S CURRENT
								ACCREDITATION STATUS IN </span>
						</div>
						<div class="col-sm-1"></div>
					</div>

					<div class="row">
						<div class="col-sm-1"></div>
						<div class="col-sm-10">
							<span style="font-size: 9pt">OREGON.</span>
						</div>
						<div class="col-sm-1"></div>
					</div>

					<div class="row" style="margin-top: 70pt">
						<div class="col-sm-1"></div>
						<div class="col-sm-4" style="border-top:solid; font-size: 11pt">
							<div class="row">
								<div class="col-sm-12">
									{{ certData.administrator }}
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12">
									{{ certData.certificateFacility }}
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12">
									{{ certData.certificateTitle }}
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12">
									7202 NE Evergreen Parkway, Suite 100
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12">
									Hillsboro, OR 97124
								</div>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-sm-12" style="text-align:center">
							<span style="font-size: 11pt">EFFECTIVE DATE : &nbsp;<strong>{{ issueDate }}</strong></span>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12" style="text-align:center">
							<span style="font-size: 11pt">EXPIRATION DATE : &nbsp;<strong>{{ expirationDate }}</strong></span>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12" style="text-align:center">
							<span style="font-size: 11pt">Certificate No : <strong>{{ certData.certificateNumber }}</strong></span>
						</div>
					</div>
				</div>
			</div>

		</kendo-pdf-export>

	</mat-card-content>
</mat-card>